import { useCallback, useMemo, useRef, useState } from 'react';
import { saveTxtSelections, uploadTxtResults } from '../services/denemeTxtService';

const extractSablonId = (payload) => (
  payload?.data?.id || payload?.id || payload?.data?.sablon_id || payload?.sablon_id || null
);

export default function useTxtLearningFlow(denemeId) {
  const inFlightRef = useRef(false);
  const [savingTemplate, setSavingTemplate] = useState(false);
  const [uploadingTxt, setUploadingTxt] = useState(false);
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);

  const loading = useMemo(() => savingTemplate || uploadingTxt, [savingTemplate, uploadingTxt]);

  const runSaveAndUpload = useCallback(async ({ templatePayload, files }) => {
    if (!denemeId) throw new Error('Deneme seçilmedi.');
    if (inFlightRef.current) throw new Error('İşlem devam ediyor.');

    inFlightRef.current = true;
    setError(null);
    setResult(null);

    try {
      setSavingTemplate(true);
      const saveResponse = await saveTxtSelections(templatePayload);
      setSavingTemplate(false);

      const sablonId = extractSablonId(saveResponse);
      if (!sablonId) throw new Error('Şablon kaydedildi ancak sablon_id bulunamadı.');

      setUploadingTxt(true);
      const uploadResponse = await uploadTxtResults({ denemeId, files, sablonId });
      setUploadingTxt(false);

      const flowResult = { saveResponse, uploadResponse, sablonId };
      setResult(flowResult);
      return flowResult;
    } catch (err) {
      setSavingTemplate(false);
      setUploadingTxt(false);
      setError(err);
      throw err;
    } finally {
      inFlightRef.current = false;
    }
  }, [denemeId]);

  return {
    runSaveAndUpload,
    loading,
    savingTemplate,
    uploadingTxt,
    error,
    result,
    inFlightRef,
  };
}
